import { ButtonToggle, Chip, Flex, Link, Text } from '@servicetitan/anvil2';
import { buttonToggle } from './ProviderSelection.module.scss';
import { useProviderPreferences } from './useProviderPreference';
import { ProviderAndLogo } from './ProviderAndLogo';
import { useState } from 'react';
import { useBreakpoint } from '@servicetitan/financing-utils-shared';
import { SetupData, SetupDataStore } from '@servicetitan/financing-workflow-shared';

export const ProviderSelection = () => {
    const { enabledProviders, preferredProvider } = useProviderPreferences();
    const { setupData, setSetupData } = SetupDataStore.useStore();
    const { isXs } = useBreakpoint();
    const [showAll, setShowAll] = useState(false);
    const visibleProviders = isXs && !showAll ? enabledProviders?.slice(0, 3) : enabledProviders;
    const showOverflowButton = isXs && enabledProviders.length > 3;

    const setProvider = (provider: string) => {
        setSetupData((prev: SetupData) => ({
            ...prev!,
            provider,
        }));
    };
    const provider = setupData?.provider;

    return (
        <Flex direction="column" gap="2">
            <Flex>
                <Text>Provider&nbsp;</Text>
                <Text style={{ color: 'red' }}>*</Text>
            </Flex>
            <Flex direction="column" wrap="wrap" gap="4" sm={{ direction: 'row' }}>
                {visibleProviders.map(p => (
                    <ButtonToggle
                        key={p}
                        className={buttonToggle}
                        onClick={() => setProvider(p!)}
                        checked={provider === p}
                    >
                        <Flex
                            gap="2"
                            grow={1}
                            justifyContent="space-between"
                            alignItems="center"
                            sm={{ direction: 'column', alignItems: 'baseline' }}
                        >
                            <ProviderAndLogo
                                provider={p}
                                showPreferredProviderChip={preferredProvider === p && isXs}
                            />
                        </Flex>
                        {preferredProvider === p && !isXs && (
                            <Flex alignSelf="baseline">
                                <Chip label="Preferred" />
                            </Flex>
                        )}
                    </ButtonToggle>
                ))}
            </Flex>
            {showOverflowButton && (
                <Link
                    ghost
                    onClick={() => setShowAll(!showAll)}
                    alignSelf="center"
                    style={{ paddingTop: '8px' }}
                >
                    {showAll ? 'Show less providers' : 'Show more providers'}
                </Link>
            )}
        </Flex>
    );
};
